// extracted by mini-css-extract-plugin
export default {"wrapper":"Yea-z","play":"Zea-z"};